module.exports = __webpack_public_path__ + "img/alanc-pro.392f0ac3.jpg";